/**
 * Support article explaining how the Team Finder works, opened from the help
 * icon beside the page title.
 */
export const TEAM_FINDER_SUPPORT_URL =
  'https://support.sportninja.com/player-finder'
